<template>
    <Dialog :header="$t('review_confirmation')" v-model:visible="showReviewConfirmationModal" :closeOnEscape="false"
        :closable="false" :modal="true" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '35vw' }">
        <div v-if="!processed" class="p-inputtext-sm p-fluid">
            <div class="grid">
                <div class="col-12">
                    <div class="field grid">
                        <label for="Mail_To" class="col-4">Mail To<span style="color: red;">*</span></label>
                        <div class="col-8 md-8">
                            <CustomMultiSelect class="p-inputtext-sm" v-model="Mail_To" type="text"
                                placeholder="Select Employee" :url="this.$API_URL + 'list/employee_id'" :minLength="0"
                                :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'"
                                :class="{ 'p-invalid': submitted && !Mail_To }" />
                            <small class="p-error" v-if="!this.Mail_To && submitted">
                                {{ $t('is_required').replace('Value', 'Mail to') }}
                            </small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="Mail_Cc" class="col-4">Mail Cc</label>
                        <div class="col-8 md-8">
                            <CustomMultiSelect class="p-inputtext-sm" v-model="Mail_Cc" type="text"
                                placeholder="Select Employee" :url="this.$API_URL + 'list/employee_id'" :minLength="0"
                                :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <center>
                <div v-if="resultData.success">
                    <Button icon="pi pi-check" class="p-button-rounded p-button-outlined mr-2 mb-2" /><br>
                    <Button :label="resultData.message" class="p-button-success p-button-text mr-2 mb-2" />
                </div>
                <div v-else>
                    <Button icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" /><br>
                    <Button :label="resultData.message" class="p-button-danger p-button-text mr-2 mb-2" />
                </div>
            </center>
        </div>

        <template #footer>
            <div v-if="processed">
                <Button label="Close" @click="dismissConfirmation()" />
            </div>
            <div v-else>
                <div v-if="processing">
                    <ProgressSpinner style="width:50px;height:50px" />
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button label="Cancel" @click="dismissConfirmation()" />
                        <Button label="Send Mail" autofocus @click="sendReminder()"
                            class="pi-button p-button-warning" />
                        <ConfirmPopup></ConfirmPopup>
                    </div>
                    <div v-else>
                        <Button label="Close" autofocus icon="pi pi-times" class="p-button-text"
                            @click="dismissConfirmation()" />
                    </div>
                </div>
            </div>
        </template>
    </Dialog>

    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Statistical Report</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div style="font-style: italic;color:red;">{{ $t('auth_report') }}
                    <Button :label="$t('click_here')" class="p-button p-component p-button-link"
                        @click="showReportAuth()"
                        style="color: red;margin-bottom: -7px;margin-left: -10px;font-weight: bold;font-style: italic;text-decoration: underline;" />
                </div>
                <div v-if="header && this.Error_Message && !this.submitted">
                    <Message severity="warn" :closable="false" v-html="this.Error_Message">
                    </Message>
                </div>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Unit_Code" class="col-4">{{ $t('unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="UnitCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/unit_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Functional_Code" class="col-4">{{ $t('functional') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="FunctionalCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/functional_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Department_Code" class="col-4">{{ $t('department') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DepartmentCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/department_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Grade_Code" class="col-4">{{ $t('grade') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.GradeCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/grade_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                </div>
                            </div>
                            <!-- <div class="field grid">
                                <label for="Section_Code" class="col-4">{{ $t('section') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="SectionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/section_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Grade_Type" class="col-4">{{ $t('report_type') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Grade_Type" :filter="true"
                                        :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'Report_Type' }" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Name" class="col-4">{{ $t('name') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name" v-model="header.Name" required="true" type="text"
                                        :placeholder="$t('name')" />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Company_Code" class="col-4">{{ $t('company') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="CompanyCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/company_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Division_Code" class="col-4">{{ $t('division') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DivisionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/division_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Region" class="col-4">{{ $t('business_unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="Region" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'REGION' }" :filter="true" :optionValue="'id'"
                                        :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Directorate_Code" class="col-4">{{ $t('directorate') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DirectorateCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/directorate_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Period_Year" class="col-4">{{ $t('appraisal_period') }}</label>
                                <div class="col-8 md-8">
                                    <Dropdown v-model="header.Period_Year" :options="years" optionLabel="value"
                                        optionValue="value" :placeholder="$t('year')" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="source" class="col-4">{{ $t('source') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.Source" :filter="true"
                                        :url="this.$API_URL + 'list/lookup'" :minLength="0" placeholder="All"
                                        :params="{ group: 'SOURCE' }" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="generate()" icon="pi pi-external-link" />
                <br />
                <div class="p-inputtext-sm p-fluid" v-if="this.reportTbl">
                    <center>
                        <h4>Recapitulation PA</h4>
                    </center>
                    <div class="grid">
                        <div class="col-10">
                            <table style="width: 100%;" id="tableCriteria">
                                <thead>
                                    <tr>
                                        <td colspan="6" style="font-weight: bold;">Criteria</td>
                                    </tr>
                                    <tr>
                                        <td style="font-weight: bold;width: 10%;">Grade</td>
                                        <td style="font-weight: bold;width: 10%;">% Standard</td>
                                        <td style="font-weight: bold;width: 10%;">Amount</td>
                                        <td style="font-weight: bold;width: 10%;">% Realization</td>
                                        <td style="font-weight: bold;width: 40%;">Compatibility</td>
                                        <td style="font-weight: bold;width: 20%;">Remarks</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(qt, index) in [...new Set(this.reportTbl)]" v-bind:key="qt.Grade">
                                        <td>{{ qt.Grade }}</td>
                                        <td>
                                            {{ qt.Standard }} %</td>
                                        <td :style="[{ 'color': qt.BgColor, 'font-weight': 'bold' }]">
                                            {{ qt.Amount }}</td>
                                        <td :style="[{ 'color': qt.BgColor, 'font-weight': 'bold' }]">
                                            {{ qt.Amount_Persen.toString().includes(".") ?
                                            qt.Amount_Persen.toString().substr(0, 2).replace('.', '') + '.' +
                                            qt.Amount_Persen.toString().split('.')[1].substr(0, 2)
                                            : qt.Amount_Persen }} %</td>
                                        <td>
                                            {{ qt.Compatibility }}</td>
                                        <td rowspan="this.reportTbl.length"
                                            v-if="index == 0 && this.reportTbl.filter(a => a.Is_Pass == true).map(a => a.Is_Pass).length == 3">
                                            <b>Proceed to the directorate level</b>
                                        </td>
                                        <td :rowspan="this.reportTbl.length"
                                            v-if="index == 0 && this.reportTbl.filter(a => a.Is_Pass == true).map(a => a.Is_Pass).length != 3">
                                            <b>Please review at the unit committee to adjust the appraisal criteria</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td colspan="3">{{ this.Total }}</td>
                                        <td colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-2" v-if="this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO">
                            <Button type="button"
                                class="p-button p-component p-button-rounded p-button-warning mr-2 mb-2"
                                label="Click to Review" @click="showModal()" icon="pi pi-send" />
                        </div>
                    </div>
                    <div class="grid" v-if="this.assedTbl">
                        <div class="col-8">
                            <table style="width: 100%;">
                                <thead>
                                    <tr>
                                        <td style="font-weight: bold;width: 55%;">Data</td>
                                        <td style="font-weight: bold;width: 10%;">Amount</td>
                                        <td style="font-weight: bold;width: 10%;">%</td>
                                        <td style="font-weight: bold;width: 25%;">Remarks</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="text-align: left;">Employees has been assessed</td>
                                        <td>{{ this.assedTbl.filter(a => a.Grade == "Assed")[0].Amount }}</td>
                                        <td
                                            :style="[(this.assedTbl.filter(a => a.Grade == 'Assed')[0].Amount_Persen) == 100 ?
                                            { 'color': 'green', 'font-weight': 'bold' } : { 'color': 'red', 'font-weight': 'bold' }]">
                                            {{
                                            this.assedTbl.filter(a => a.Grade ==
                                            "Assed")[0].Amount_Persen.toString().includes(".") ?
                                            this.assedTbl.filter(a => a.Grade ==
                                            "Assed")[0].Amount_Persen.toString().substr(0, 2).replace('.', '') + '.' +
                                            this.assedTbl.filter(a => a.Grade ==
                                            "Assed")[0].Amount_Persen.toString().split('.')[1].substr(0, 2)
                                            : this.assedTbl.filter(a => a.Grade == "Assed")[0].Amount_Persen
                                            }} %</td>
                                        <td rowspan="2"
                                            :style="[(this.assedTbl.filter(a => a.Grade == 'Assed')[0].Amount_Persen) == 100 ?
                                            { 'color': 'green', 'font-weight': 'bold' } : { 'color': 'red', 'font-weight': 'bold' }]">
                                            <b>{{ (this.assedTbl.filter(a => a.Grade == 'Assed')[0].Amount_Persen) ==
                                                100 ? "Completed" : "Incompleted" }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: left;">
                                            Employees has not been assessed <br />
                                            <b>(Tidak termasuk Golongan 10, karyawan dengan status TERMINASI & EXPATRIAT
                                                serta karyawan yang bergabung setelah "{{ this.cutoffDate }}")</b>
                                        </td>
                                        <td>{{ this.assedTbl.filter(a => a.Grade == "Not Assed")[0].Amount }}</td>
                                        <td
                                            :style="[(this.assedTbl.filter(a => a.Grade == 'Not Assed')[0].Amount_Persen) == 0 ?
                                            { 'color': 'green', 'font-weight': 'bold' } : { 'color': 'red', 'font-weight': 'bold' }]">
                                            {{
this.assedTbl.filter(a => a.Grade == "Not Assed")[0].Amount_Persen.toString().includes(".") ?
this.assedTbl.filter(a => a.Grade == "Not Assed")[0].Amount_Persen.toString().substr(0, 2).replace('.', '') + '.' +
this.assedTbl.filter(a => a.Grade == "Not Assed")[0].Amount_Persen.toString().split('.')[1].substr(0, 2)
: this.assedTbl.filter(a => a.Grade == "Not Assed")[0].Amount_Persen
                                            }} %
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="text-align: left;">Total</td>
                                        <td>{{ this.TotalAssed }}</td>
                                        <td colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <br />
                <center>
                    <h4 v-if="this.reportTbl">Performance Appraisal</h4>
                </center>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <Chart type="bar" :data="this.chartData()" :options="barOptions" :height="190"
                                v-if="this.reportTbl" />
                            <Chart type="pie" :data="this.chartData()" :options="barOptions" class="w-full md:w-25rem"
                                v-if="this.reportTbl" />
                        </div>
                        <div class="col-6">
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>

    <ReportAuth v-if="reportAuth" :isVisible="reportAuth" :initialErrorMessage="errormessage"
        @hide="hideReportAuthDialog" />
</template>

<script>
export default {
    data() {
        return {
            test: 0,
            mode: "",
            dataUrl: "Report/statistical_report",
            mailUrl: "Report/mail_criteria",
            reportTbl: null,
            assedTbl: null,
            showReport: false,
            loadingReport: false,
            Error_Message: "",
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            UnitCode: null,
            FunctionalCode: null,
            DepartmentCode: null,
            GradeCode: null,
            SectionCode: null,
            CompanyCode: null,
            DivisionCode: null,
            Region: null,
            DirectorateCode: null,
            Source: null,
            header: {
                Unit_Code: null,
                Functional_Code: null,
                Department_Code: null,
                Grade_Code: null,
                Section_Code: null,
                Company_Code: null,
                Division_Code: null,
                Period_Year: new Date().getFullYear(),
                Region: null,
                Source: null,
                Directorate_Code: null,
                Name: "",
                Is_Export: false,
                Grade_Type: "All"
            },
            submitted: false,
            barOptions: null,
            dataBar: [],
            Mail_To: "",
            Mail_Cc: "",
            showReviewConfirmationModal: false,
            processed: false,
            processing: false,
            cutoffDate: null,
            reportAuth: false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport;
        },
        generate() {
            this.Error_Message = "";
            this.getReport();
        },
        getReport() {
            var self = this;
            this.$emit('block-ui');

            this.header.Unit_Code = this.UnitCode ? this.UnitCode.join(',') : '';
            this.header.Functional_Code = this.FunctionalCode ? this.FunctionalCode.join(',') : '';
            this.header.Department_Code = this.DepartmentCode ? this.DepartmentCode.join(',') : '';
            this.header.Grade_Code = this.GradeCode ? this.GradeCode.join(',') : '';
            this.header.Section_Code = this.SectionCode ? this.SectionCode.join(',') : '';
            this.header.Company_Code = this.CompanyCode ? this.CompanyCode.join(',') : '';
            this.header.Division_Code = this.DivisionCode ? this.DivisionCode.join(',') : '';
            this.header.Region = this.Region ? this.Region.join(',') : '';
            this.header.Directorate_Code = this.DirectorateCode ? this.DirectorateCode.join(',') : '';
            this.header.Source = this.Source;

            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    if (response.data.success) {
                        this.reportTbl = response.data.data.listReport;
                        this.assedTbl = response.data.data.listAssed;
                        this.cutoffDate = response.data.data.cutoffDate;
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
                .finally(() => {
                    self.dataBar = self.reportTbl.map(a => a.Amount);
                    this.applyLightTheme();
                });
        },
        chartData() {
            return {
                labels: this.reportTbl.map(a => a.Grade),
                datasets: [
                    {
                        label: ['Grade'],
                        data: this.dataBar,
                        backgroundColor: ['#00C45C', '#FFD45C', '#00659B'],
                        borderColor: ['#00C45C', '#FFD45C', '#00659B'],
                        borderWidth: 1,
                        sliced: true
                    }
                ]
            }
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
        applyLightTheme() {
            this.barOptions = {
                plugins: {
                    legend: {
                        labels: {
                            color: '#495057',
                            usePointStyle: true
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        title: 'deferfe'
                    },
                }
            };
        },
        sendReminder() {
            this.submitted = true;
            if (!this.Mail_To) {
                return;
            } else {
                var self = this;
                self.processing = true;

                var model = {
                    Mail_To: this.Mail_To.join(','),
                    Mail_Cc: this.Mail_Cc ? this.Mail_Cc.join(',') : '',
                    Mail_Body: document.getElementById('tableCriteria').outerHTML
                };

                this.$axios.post(this.$API_URL + this.mailUrl, model)
                    .then((response) => {
                        if (response.data.success) {
                            self.processed = true;
                            self.processing = false;

                            // if (response.data.success)
                            //     this.$toast.add({ severity: 'success', summary: 'Email Sent', detail: response.data.message, life: 5000 });
                            // else
                            //     self.showError('Error Sent Email', response.data.message);

                            self.resultData = response.data;
                        }
                    })
                    .catch(function (error) {
                        self.processed = false;
                        self.processing = false;
                        self.showError('Error Sent Email', error);
                    });
            }
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        dismissConfirmation() {
            this.processed = false;
            this.showReviewConfirmationModal = false;
            this.submitted = false;
        },
        showModal() {
            this.showReviewConfirmationModal = true;
            this.Mail_To = '';
            this.Mail_Cc = '';
        },
        showReportAuth() {
            this.reportAuth = true;
        },
        hideReportAuthDialog() {
            this.reportAuth = false;
        }
    },
    mounted() {
    },
    computed: {
        years() {
            let years = [];
            for (var i = new Date().getFullYear(); i >= 2023; i--) {
                years.push({ value: i.toString() })
            }
            return years;
        },
        Total() {
            if (this.reportTbl) {
                const dataArray = this.reportTbl.map(a => a.Amount);
                const reducer = (accumulator, curr) => accumulator + curr;
                return dataArray.reduce(reducer);
            }
            else {
                return 0;
            }
        },
        TotalAssed() {
            if (this.assedTbl) {
                const dataArray = this.assedTbl.map(a => a.Amount);
                const reducer = (accumulator, curr) => accumulator + curr;
                return dataArray.reduce(reducer);
            }
            else {
                return 0;
            }
        }
    }
};
</script>

<style scoped>
table,
th,
td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    padding: 5px;
    font-size: 1rem;
}
</style>